/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_Tx_PurchaseInputs */

const cs_public_site_demand_tx_purchase = /** @type {(inputs: Public_Site_Demand_Tx_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koupě`)
};

const en_public_site_demand_tx_purchase = /** @type {(inputs: Public_Site_Demand_Tx_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase`)
};

/**
* | output |
* | --- |
* | "Purchase" |
*
* @param {Public_Site_Demand_Tx_PurchaseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_tx_purchase = /** @type {((inputs?: Public_Site_Demand_Tx_PurchaseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_Tx_PurchaseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_tx_purchase(inputs)
	return cs_public_site_demand_tx_purchase(inputs)
});